export default __webpack_public_path__ + "static/media/coach-icon-spinner.e2beb8ee.gif";